// 홈 메뉴 공통 링크 정의
export const getHomeLinks = () => [
  { path: '/StatisticList', label: '대시보드' },
  { path: '/BoardAdmin', label: '메뉴관리' },
  { path: '/StandardInfo', label: '기준정보 관리' },
  { path: '/StandardInfo_Dtail', label: '기준정보 상세' },
  { path: '/SystemGuide', label: '시스템 메뉴얼' },
  { path: '/OrganizationManagement', label: '권한관리' },
  { path: '/SystemLog', label: '시스템로그' },
];